import SliderPhotos from "./SliderPhotos";

export default SliderPhotos;